






















































































import { Component, Vue, Inject } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Search, SortDirection } from '@/data/models/search.model';
import { Asl } from '@/data/models/asl.model';
import  LuogoEditModal  from './luogo/LuogoEditModal.vue';

@Component({
	components: {
		LuogoEditModal
	}
})
export default class LuogoList extends Vue {
	
	@Inject('CrudService') crudService!: CrudService<Asl>;

	rows: Asl[] = [];
	loading: boolean = false;
	advancedSearch: Search = new Search('asl');

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadData() {

		const datareq = this.crudService.searchEntities(
			Asl,
			'asl',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Asl,
			'asl',
			this.advancedSearch
		);

		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadData();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadData();
	}

	editLuogo(item: Asl) {
		this.$emit('edit', item);
	}

	deleteLuogo(item: Asl) {
		this.$emit('delete', item);
	}

}
